import { render, staticRenderFns } from "./SetDrinkSoldQuantityMap.vue?vue&type=template&id=71e6f795"
import script from "./SetDrinkSoldQuantityMap.vue?vue&type=script&lang=js"
export * from "./SetDrinkSoldQuantityMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports